// Packages
import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled, { css } from "styled-components"

// Components
import SEO from "@components/global/seo"

const size = {
  tablet: 850,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Wrapper = styled.div`
  max-width: 1248px;
  padding: 0 48px;
  margin: 88px auto 96px;
  ${below.tablet`
    margin: 48px auto 72px;
  `};
  ${below.mobile`
  padding: 0 24px;
  margin:  32px auto 40px;
  `}
`
const IframeWrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;

  .resp-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`

const LiveWorkHarmony = () => {
  const data = useStaticQuery(graphql`
    {
      hero: file(relativePath: { regex: "/global/hero-default.jpg/" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, layout: FULL_WIDTH)
        }
      }
    }
  `)
  return (
    <>
      <Wrapper>
        <section>
          <IframeWrapper>
            <iframe
              className="resp-iframe"
              src="https://cdn.flipsnack.com/widget/v2/widget.html?hash=ftunwii9d&bgcolor=EEEEEE&t=1542207152"
              width="100%"
              height="100%"
              seamless="seamless"
              scrolling="no"
              frameBorder="0"
              title="inlinePDF"
              allowFullScreen
            />
          </IframeWrapper>
        </section>
      </Wrapper>
    </>
  )
}

// Meta tags
export const Head = () => {
  return (
    <SEO
      description={`Live and work in harmony at Atlantic Bay Mortgage Group®.`}
      title={`Live and Work in Harmony | Atlantic Bay Mortgage Group®`}
      slug={`live-work-harmony`}
    />
  )
}
export default LiveWorkHarmony
